import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css";
import {
  New_ScrollX2025,
  Scrollx_animate,
  SliderArrowIcon,
  Star_particles,
  loginCreditImg,
} from "../../assets/icons";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { Checkbox } from "../../Components";
import VerifyOTPModal from "./VerifyOtp";
import SignUpWithGoogle from "../GoogleSignUp/SignUpWithGoogle";
import { useDispatch } from "react-redux";
import { register, resndOTP, verifyOTP } from "../../Redux/actions/authActions";
import { addSurvey } from "../../Redux/actions/commonActtion";
import LoaderGlobal from "../../Components/Loader/LoaderGlobal";

export default function NewSignup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const otpType = "signUp";
  const [otp, setOpt] = useState("");
  const [inValidOtp, setInValidOtp] = useState("");
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [path, setPath] = useState("");
  // const [successModal, setSuccessModal] = useState(false);
  // const [errorMesg, setErrorMesg] = useState("");
  const [isTermsandcon, setIsTermsandcon] = useState(false);
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [dropDowntwo, setDropDownTwo] = useState(false);

  const [terms, setTerms] = useState(false);
  const [termsConditionsError, setTermsConditionError] = useState("");

  const [error, setError] = useState("");
  const [answer, setAnswer] = useState({
    value: "",
    label: "",
  });
  const [answerTwo, setAnswerTwo] = useState({
    value: "",
    label: "",
  });

  const [move, setMove] = useState(false);

  const data = [
    {
      id: "search",
      value: "googleSearch",
      label: "Google",
      disabled: false,
      selected: false,
    },
    {
      id: "search",
      value: "googleSearchNew",
      label: "Google Search",
      disabled: false,
      selected: false,
    },
    {
      id: "meta",
      value: "MetaAds",
      label: "Facebook",
      disabled: false,
      selected: false,
    },
    {
      id: "insta",
      value: "instaAds",
      label: "Instagram",
      disabled: false,
      selected: false,
    },
    {
      id: "youtube",
      value: "youtubeAds",
      label: "YouTube",
      disabled: false,
      selected: false,
    },
    {
      id: "friend",
      value: "fromAFriendNew",
      label: "From a friend",
      disabled: false,
      selected: false,
    },
    {
      id: "friend",
      value: "fromAFriend",
      label: "Other",
      disabled: false,
      selected: false,
    },
  ];

  const data2 = [
    {
      id: "post",
      value: "postProducer",
      label: "Post Producer",
      disabled: false,
      selected: false,
    },
    {
      id: "filmMaker",
      value: "filmMaker",
      label: "Film Maker",
      disabled: false,
      selected: false,
    },
    {
      id: "agency",
      value: "agency",
      label: "Agency",
      disabled: false,
      selected: false,
    },
    {
      id: "editor",
      value: "editor",
      label: "Editor",
      disabled: false,
      selected: false,
    },
    {
      id: "student",
      value: "student",
      label: "Student",
      disabled: false,
      selected: false,
    },
  ];

  const [form, setForm] = useState({
    data: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      company: "",
      password: "",
      confirmPassword: "",
      isTermsandcon: isTermsandcon,
    },
    errorMessage: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      company: "",
      password: "",
      confirmPassword: "",
    },
  });

  const handleSelectSurvey = (value, label) => {
    setAnswer({ value, label });
    setDropDown(false);
  };

  const handleSelectSecondSurvey = (value, label) => {
    setAnswerTwo({ value, label });
    setDropDownTwo(false);
  };

  const onSubmitHandler = async (answer, answerTwo) => {
    setDropDown(false);
    if (!answer) {
      alert("Please select an option.");
      return;
    }
    try {
      await dispatch(addSurvey(answer, answerTwo));
      localStorage.setItem("userFilledSurvey", JSON.stringify(true));
    } catch (error) {
      alert("Failed to submit the survey. Please try again.");
    }
  };

  const onChangeHandler = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setForm((prevForm) => {
      const newForm = { ...prevForm };
      if (name === "firstName" || name === "lastName") {
        newForm.errorMessage[name] =
          value.length < 2 ? "Name is too short" : "";
      } else if (name === "phoneNo") {
        newForm.errorMessage[name] =
          value.length < 10 || value.length > 12 ? "Enter 10 digit" : "";
      } else if (name === "password") {
        newForm.errorMessage[name] =
          value.length < 8 ? "Password must be at least 8 characters" : "";
      } else if (name === "confirmPassword") {
        newForm.errorMessage[name] =
          value !== form.data.password ? "Confirm Password must match" : "";
      } else if (name === "email") {
        newForm.errorMessage[name] = "";
      }
      const formValues = { ...form, data: { ...form.data, [name]: value } };
      return {
        ...newForm,
        data: formValues.data,
        errorMessage: newForm.errorMessage,
      };
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (answer.value === "") {
      setError("Please select an option. ");
    } else if (terms) {
      setSignupLoading(true);
      const res = await dispatch(register(form?.data));
      const resError = res?.response?.data?.error;
      if (res?.status === 200) {
        if (res?.data?.success) {
          setSignupLoading(false);
          setIsSignUpSuccess(true);
        }
      } else if (resError && resError?.includes("User with email")) {
        form.errorMessage.email = "Email already exist";
        setSignupLoading(false);
        setForm({ ...form });
      } else {
        form.errorMessage.email = "";
        setSignupLoading(false);
        setForm({ ...form });
      }
    } else {
      setTermsConditionError("Please accept the terms and conditions");
    }
  };

  const handleSubmitOtp = async () => {
    if (otp) {
      const user = JSON.parse(localStorage.getItem("dup-user"));
      const res = await dispatch(verifyOTP(user.email, otp, otpType, ""));
      if (res?.data === "Successfully verified") {
        setIsSignUpSuccess(false);
        onSubmitHandler(answer.value, answerTwo.value);
        // navigate("dashboard");
        navigate("/dashboard/new-user");
        setOpt("");
        setInValidOtp("");
      } else if (res?.response?.data === "Invalid otp") {
        setInValidOtp(res?.response?.data);
      }
    }
  };

  const handleResendOtp = async () => {
    const res = await dispatch(resndOTP());
    if (res?.data?.message === "otp Resent successsful") {
      setInValidOtp(`OTP Resent Check Your Mail Agian`);
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClick = () => {
    setMove(true); // Move to 0px

    setTimeout(() => {
      setMove(false); // Return to 100px after a short delay
    }, 3000); // Adjust the delay as needed (1000ms = 1 second)
  };

  return (
    <>
      {isSignUpSuccess && (
        <VerifyOTPModal
          isSignUpSuccess={isSignUpSuccess}
          setIsSignUpSuccess={setIsSignUpSuccess}
          otp={otp}
          setOpt={setOpt}
          handleSubmitOtp={handleSubmitOtp}
          handleResendOtp={handleResendOtp}
          inValidOtp={inValidOtp}
          setInValidOtp={setInValidOtp}
        />
      )}

      {signupLoading && (
        <div className="modal-overlayLoader">
          <img
            className="absolute opacity-80 LoadOnProjectimg"
            src={Scrollx_animate}
            width="120px"
            height="120px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Signing Up...</p>
          {/* <LoaderGlobal /> */}
        </div>
      )}

      <div className={"main_div"}>
        <div className="w-full h-full flex ScalingSignPAge relative">
          {/* Left Block */}
          <div className="flex lg:hidden py-3 w-full  items-center justify-center bg-[#1e1f2a] absolute ">
            <img className="w-[35px]" src={New_ScrollX2025} alt="icon" />
            <span className="ml-[10px] text-white Syne text-xl font-light tracking-wide manrope-600">
              ScrollX.io
            </span>
          </div>
          <div className="lg:w-[45%] w-[100%] loginRight-block flex justify-center items-center bg-[#1e1f2a]">
            <div className=" lg:w-[57%] w-[83%] h-1/2 flex flex-col justify-center items-center relative loginRight-blockPhone">
              <img
                className="w-[350px] absolute left-[-40%] lg:top-[-10%] top-[-40%]"
                src={Star_particles}
                alt=""
              />

              <div className="w-[90%] flex flex-col justify-center items-start ">
                <h1 className="text-white lg:text-4xl  text-[33px]   manrope-600 ">
                  Get Started Now
                </h1>
                <h2 className="white-80 xl:text-[15px] manrop-400 pt-3 pb-4">
                  Enter to create your account. Have an account?{" "}
                  <Link to="/">
                    <span className="text-white xl:text-[15px] manrope-600 underline">
                      Sign In
                    </span>{" "}
                  </Link>
                </h2>
              </div>
              <div className="w-[90%]  flex items-center  ">
                <SignUpWithGoogle />
              </div>
              <div className="w-[90%] flex justify-center items-center pt-[14px]">
                <div className="w-[45%] h-[1px] self-center bg-[#797979] "></div>
                <div className="w-[10%]   text-center manrope-400  xl:text-lg text-white">
                  or
                </div>
                <div className="w-[45%]  h-[1px] self-center bg-[#797979]"></div>
              </div>

              <div className="w-full">
                <form onSubmit={submitHandler}>
                  <div className="mb-6 mt-6 flex w-full justify-center">
                    <div className="w-[90%]">
                      <input
                        className="input_signup_block text-white manrope-400"
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={form?.data?.firstName}
                        onChange={(e) => onChangeHandler(e)}
                        placeholder="Full Name"
                        required
                      />
                      {form?.errorMessage?.firstName && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>
                          {form?.errorMessage?.firstName}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className=" flex justify-center mb-6">
                    <div className="w-[90%]  ">
                      <input
                        className="input_signup_block manrope-400"
                        type="email"
                        id="email"
                        name="email"
                        value={form?.data?.email}
                        onChange={(e) => onChangeHandler(e)}
                        placeholder="Email Address"
                        required
                      />
                      {form?.errorMessage?.email && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>
                          {form?.errorMessage?.email}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="mb-6 flex justify-center">
                    <div className="w-[90%]">
                      <div className="flex items-center relative">
                        <input
                          className="input_signup_block manrope-400 "
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          value={form?.data?.password}
                          onChange={(e) => onChangeHandler(e)}
                          autoComplete="on"
                          placeholder="Password"
                          required
                        />
                        <div
                          onClick={handleShowPassword}
                          className="absolute lg:right-4 right-5 text-black lg:w-5 lg:h-5 cursor-pointer text-white"
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                      </div>
                      {form?.errorMessage.password && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>
                          {form?.errorMessage?.password}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="mb-6 flex justify-center cursor-pointer">
                    <div className="w-[90%]">
                      <div className="flex items-center">
                        <div className="w-full">
                          <div
                            className="surveySelect flex justify-between items-center manrope-400"
                            onClick={() => setDropDownTwo(!dropDowntwo)}
                          >
                            <span className="lg:py-0 py-[2px]">
                              {answerTwo.label === ""
                                ? "What suits you the best?"
                                : answerTwo.label}
                            </span>{" "}
                            {dropDowntwo ? <FaAngleUp /> : <FaAngleDown />}
                          </div>
                          {dropDowntwo && (
                            <div className="absolute border-[1px] h-[11rem] z-10 w-[90%] text-white overflow-auto  bg-[#1e1f2a] border-[#ffffff90] mt-2 rounded">
                              {data2.map((item) => (
                                <div
                                  className="hover:bg-[#ffffff33] manrope-400 cursor-pointer py-[.7rem] px-4 border-[#ffffff33] border-b-[1px]"
                                  key={item.id}
                                  value={item.value}
                                  onClick={() =>
                                    handleSelectSecondSurvey(
                                      item.value,
                                      item.label
                                    )
                                  }
                                >
                                  {item.label}
                                </div>
                              ))}
                            </div>
                          )}
                          {error && (
                            <span
                              style={{ color: "#c64747", fontSize: "12px" }}
                            >
                              {error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-6 flex justify-center cursor-pointer">
                    <div className="w-[90%]">
                      <div className="flex items-center">
                        <div className="w-full">
                          <div
                            className="surveySelect flex justify-between items-center manrope-400"
                            onClick={() => setDropDown(!dropDown)}
                          >
                            <span className="lg:py-0 py-[2px]">
                              {answer.label === ""
                                ? "Where did you discover ScrollX?"
                                : answer.label}
                            </span>{" "}
                            {dropDown ? <FaAngleUp /> : <FaAngleDown />}
                          </div>
                          {dropDown && (
                            <div className="absolute border-[1px] h-[11rem] z-10 w-[90%] text-white overflow-auto  bg-[#1e1f2a] border-[#ffffff90] mt-2 rounded">
                              {data.map((item) => (
                                <div
                                  className="hover:bg-[#ffffff33] manrope-400 cursor-pointer py-[.7rem] px-4 border-[#ffffff33] border-b-[1px]"
                                  key={item.id}
                                  value={item.value}
                                  onClick={() =>
                                    handleSelectSurvey(item.value, item.label)
                                  }
                                >
                                  {item.label}
                                </div>
                              ))}
                            </div>
                          )}
                          {error && (
                            <span
                              style={{ color: "#c64747", fontSize: "12px" }}
                            >
                              {error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-[90%] flex ml-[5%] px-1 mb-6 flex-col gap-2">
                    <Checkbox
                      label={
                        <span className="text-white text-sm manrope-400 ">
                          I agree to the {""}
                          <a
                            href="https://www.scrollx.io/terms-of-service"
                            target="_blank"
                            rel="noopener noreferrer"
                            className=" manrope-400 underline text-sm"
                          >
                            Terms & Privacy
                          </a>
                        </span>
                      }
                      setTerms={setTerms}
                      terms={terms}
                    />
                    {termsConditionsError && (
                      <span style={{ color: "#c64747", fontSize: "12px" }}>
                        {termsConditionsError}
                      </span>
                    )}
                  </div>

                  <div className=" w-[90%] ml-[5%]  overflow-hidden">
                    <button
                      type="submit"
                      className={`px-2 py-2 w-full flex justify-center bg-[#5e51d1] manrope-600  rounded-[10px] text-white xl:text-base`}
                      onClick={handleClick}
                      // disabled={
                      //   !form?.data.firstName ||
                      //   !form?.data?.email ||
                      //   !form?.data?.password
                      // }
                    >
                      <img
                        className="mr-2 lg:w-[28px] w-[40px] transition-transform duration-[1000ms] ease-in-out transform"
                        // height={25}
                        // width={25}
                        src={SliderArrowIcon}
                        alt="icon"
                        style={{ transform: `translateX(${move ? 650 : 0}px)` }}
                      />
                      <span className="manrope-600 py-[2.5px] ml-[-28px] w-full text-center">
                        Sign up
                      </span>
                    </button>
                  </div>

                  <div className="flex justify-center items-center"></div>
                </form>
              </div>
            </div>
          </div>

          {/* Right Block */}
          <div className="lg:w-[55%] lg:flex hidden bg-[#0a0a0a] flex flex-col justify-center items-center ">
            <div className="w-[55%] h-[59%] text-white ml-[15%]">
              <div>
                <div className="flex pt-2 pb-3 items-center">
                  <img className="w-[35px]" src={New_ScrollX2025} alt="icon" />
                  <span className="ml-[10px] Syne text-xl font-light tracking-wide manrope-600">
                    ScrollX.io
                  </span>
                </div>
                <h1 className="pt-2 pb-4 text-[33px] manrope-600">
                  <span className="manrope-800">
                    Start your 3-day free trial{" "}
                  </span>
                  <br />
                  and create end credits now
                </h1>
                <p className="text-base manrope-400 pr-[15%]">
                  Generate stunning, production-ready end credits that are
                  beautifully styled and perfectly structured—ready to use
                  <br />
                  within minutes.
                </p>
              </div>
              <div className="mt-[26px]">
                <img
                  className="w-[75%] opacity-[90%]  object-cover "
                  src={loginCreditImg}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
